import styled from "@emotion/styled";
import DeungiHeader from "@src/components/deungi/DeungiHeader";
import React from "react";
import BuildingRegisterPackageListBox from "./BuildingRegisterPackageListBox";
import { useNavigate, useSearchParams } from "react-router-dom";

import { WebAppBridge } from "@src/lib/WebAppBridge";

const BuildingRegisterPayment = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const inflow = searchParams.get("inflow");

    const handlePaymentSuccess = async () => {
        const selectedBuildingRegisterState = localStorage.getItem("selectedBuildingRegister");
        if (selectedBuildingRegisterState) {
            const selectedBuildingRegister = JSON.parse(selectedBuildingRegisterState);
            const address = selectedBuildingRegister.searchText;
            navigate("/buildingRegister?address=" + address + "&inflow=1");
        }
    };

    WebAppBridge.onPaymentSuccess = () => {
        if (inflow) {
            handlePaymentSuccess();
        } else {
            navigate("/buildingRegister");
        }
    };

    return (
        <Container>
            <DeungiHeader title="충전하기" />
            <div className="box">
                <BuildingRegisterPackageListBox />
            </div>
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    height: 100vh;
    height: calc(var(--vh, 1dvh) * 100);
    animation: fadeIn 0.5s forwards;
    background-color: white;

    .box {
        position: absolute;
        top: 56px;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        overflow: auto;
        overscroll-behavior-y: none;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export default BuildingRegisterPayment;
